import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
} from "@mui/material";
import {
  Warning as WarningIcon,
  Info as InfoIcon,
  Description as DescriptionIcon,
} from "@mui/icons-material";
import { useApp } from "../context/AppContext";

const ProjectChangeModal = ({ open, onClose, onConfirm, project }) => {
  const { PROJECT_TYPE_ICONS } = useApp();
  const ProjectTypeIcon = PROJECT_TYPE_ICONS[project?.type?.toLowerCase()] || DescriptionIcon;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          color: "warning.main",
        }}
      >
        <WarningIcon />
        Change Project
      </DialogTitle>

      <DialogContent>
        <Box sx={{ mb: 2 }}>
          <Typography variant="body1" gutterBottom>
            You are about to switch to the project:
          </Typography>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              bgcolor: "grey.50",
              p: 2,
              borderRadius: 1,
              border: "1px solid",
              borderColor: "grey.200",
            }}
          >
            <ProjectTypeIcon color="primary" />
            <Typography variant="h6">{project?.name}</Typography>
          </Box>
        </Box>

        <Typography variant="subtitle1" gutterBottom sx={{ color: "warning.main" }}>
          This will:
        </Typography>

        <List dense>
          <ListItem>
            <ListItemIcon>
              <InfoIcon color="warning" />
            </ListItemIcon>
            <ListItemText
              primary="Reset all current states"
              secondary="Any unsaved changes will be lost"
            />
          </ListItem>
          <ListItem>
            <ListItemIcon>
              <InfoIcon color="warning" />
            </ListItemIcon>
            <ListItemText
              primary="Clear the current conversation"
              secondary="You'll start fresh with the new project"
            />
          </ListItem>
        </List>
      </DialogContent>

      <Divider />

      <DialogActions sx={{ p: 2 }}>
        <Button onClick={onClose} variant="outlined" color="inherit">
          Cancel
        </Button>
        <Button onClick={onConfirm} variant="contained" color="warning">
          Change Project
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ProjectChangeModal;
